export default {
  primary: "black",
  secondary: "white",
  muted: "#999"
};
